import React, { useRef } from 'react'
import { vn } from 'vend-number'
import { IPromise } from 'angular'
import {
  CashPaymentInformation,
  CashPaymentModal,
} from '../../../payments/cash-payment-modal/CashPaymentModal'
import { print } from '../../../print/print'
import { useCompleteCashPayment } from '../hooks/useHandleCashPayment'
import { CashPaymentOption, SalePayment } from './types'

interface Props {
  onClose: () => void
  onSuccess: (result: SalePayment) => void
  paymentOptions: CashPaymentOption
  currencySymbol: string
}

export const Cash = ({
  paymentOptions,
  onSuccess,
  onClose,
  currencySymbol,
}: Props) => {
  const partialPayment = vn(paymentOptions.roundedAmountTendered.rounded)
    .abs()
    .lt(vn(paymentOptions.roundedBalance.rounded).abs())
  const openedCashDrawer = useRef(false)
  const rounding =
    paymentOptions.paymentType.config &&
    paymentOptions.paymentType.config.rounding
      ? paymentOptions.paymentType.config.rounding
      : '0.01'

  const openCashDrawer = () => {
    if (openedCashDrawer.current) {
      return
    }
    openedCashDrawer.current = true
    print({ type: 'open-drawer' })
  }
  const { completeRoundCashPayment } = useCompleteCashPayment(
    onSuccess,
    paymentOptions.paymentType
  )

  // FIXME: convert this to a promise once payment page is converted to react
  const handleOnClose = (result: IPromise<CashPaymentInformation>) => {
    result
      .then((data: CashPaymentInformation) =>
        completeRoundCashPayment(data, paymentOptions.paymentType)
      )
      .catch(() => {
        onClose() // In original component, rejected promises just means the modal is closed
      })
  }

  return (
    <CashPaymentModal
      amountToPay={paymentOptions.roundedAmountTendered}
      balanceRemainder={paymentOptions.roundedBalance.remainder}
      close={handleOnClose}
      currencySymbol={currencySymbol}
      isPartialPayment={partialPayment}
      openCashDrawer={openCashDrawer}
      rounding={vn(rounding)}
    />
  )
}
